import {Component, OnInit, TemplateRef} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { CustomValidator } from 'src/app/validators/custom-validator';
import { OthersService } from 'src/app/shared/services/other-services/others.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import {BsModalService} from "ngx-bootstrap/modal";
import {BsModalRef} from "ngx-bootstrap/modal/bs-modal-ref.service";
import {MicroLoanClient} from "../get-loan/get-loan.component";

@Component({
  selector: 'app-comfirm-loan',
  templateUrl: './comfirm-loan.component.html',
  styleUrls: ['./comfirm-loan.component.scss']
})
export class ComfirmLoanComponent implements OnInit {
  modalRef: BsModalRef;
  registered = false;
  submitted = false;
  errored = false;
  posted = false;
  userForm: FormGroup;
  serviceErrors: any = {};
  value: string;
  fieldType: boolean;
  User = this.authService.loggedInUserInfo();
  txns: any;
  phoneNumbers: Array<string> = [];
  approvedLoans: any;
  customers = [];
  checkedClient: MicroLoanClient;
  loanId: number;
  selectionKind: number;
  selectionData: any;
  modalTitle: string;
  constructor(
    private authService: AuthServiceService,
    private others: OthersService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private alertService: AlertService,
    private storage: AngularFireStorage,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.errored = false;
    this.posted = false;
    this.userForm = this.createFormGroup();
    this.others.getTxnApproved().subscribe(
      res => {
        if (res.length > 0){
          this.approvedLoans = res;
          this.others.getMicroCustomersByTown(this.User.userLocationId).subscribe(
            feed => {
              if (feed.length > 0){
                const customers = feed;
                this.phoneNumbers = [];
                let loans = this.approvedLoans;
                customers.forEach((customer) => {
                  loans.forEach(loan => {
                    if (JSON.parse(loan.txnApprovalDetailsMicroPayLoad)[0].customerId === customer.customerId) {
                      loans = loans.filter(ln =>
                        JSON.parse(ln.txnApprovalDetailsMicroPayLoad)[0].customerId !== customer.customerId
                    );
                      this.customers.push(customer);
                    }
                  });
                });
              } else {
                this.errored = true;
                this.alertService.danger({
                  html: '<b>There are no Micro Loan customers registered</b>'
                });
              }
            },
            err => {
              this.errored = true;
              //  //console.log(err);
              this.alertService.danger({
                html: '<b>' + err.error.mesage + '</b>'
              });
            }
        );
      } else {
        this.errored = true;
        this.alertService.danger({
          html: '<b>There are no approved loans to confirm</b>'
        });
      }
    },
      err => {
        this.errored = true;
        // console.log(err.error.error.message);
        this.alertService.danger({
          html: '<b>' + err + '</b>'
        });
      }
    );
  }
  createFormGroup(): any {
    return new FormGroup({
      pin: new FormControl(
        { value: '', disabled: false },
        Validators.compose([
          Validators.required,
          CustomValidator.patternValidator(/\d/, { hasNumber: true }),
          Validators.maxLength(4),
          Validators.minLength(4),
        ])
      ),
    });
  }
  refresh(): any {
    location.reload();
  }

  // toggle visibility of password field
  toggleFieldType(): any {
    this.fieldType = !this.fieldType;
  }

  revert(): any {
    this.userForm.reset();
  }
  getResult(res: any): void {
    this.checkedClient = res;
    if (this.checkedClient.customerPhone1) {
      this.checkLoan(this.checkedClient.customerPhone1);
    }
    this.modalRef.hide();
  }
  getClose(res: any): void {
    this.modalRef.hide();
  }

  selectFromData(template: TemplateRef<any>, kind: number): void {
    if (kind === 100) {
      this.openModal(template);
      this.selectionKind = kind;
      this.selectionData = this.customers;
      this.modalTitle = "Select a Client";
    }
  }

  getStatement(): void {

  }
  public openModal(template: TemplateRef<any>): any {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg modal-dialog-centered' })
    );
  }

  get fval(): any {
    return this.userForm.controls;
  }
  checkLoan(value: any): any {
    if (value !== ''){
      this.customers.forEach((customer) => {
        if (customer.customerPhone1 === value) {
          this.checkedClient = customer;
          this.approvedLoans.forEach(loan => {
            if (JSON.parse(loan.txnApprovalDetailsMicroPayLoad)[0].customerId === customer.customerId) {
              this.loanId = loan.txnApprovalDetailsMicroId;
            }
          });
        }
      });
    }
  }
  postLoan(): any {
    if (this.userForm.valid) {
      // this.spinner.show;;
      if (this.checkedClient.customerId) {
        if (Number(this.fval.pin.value) === this.checkedClient.customerSecretPin){
          const data = {
            txnApprovalDetailsMircroId: this.loanId,
            userId: this.User.userId
          };
          this.others.confirmMicroLoan([data]).subscribe(
            res => {
              if (res){
                this.checkedClient = null;
                this.posted = true;
                this.spinner.hide();
                this.alertService.success({
                  html: '<b> Loan was complete</b>'
                });
                this.userForm = this.createFormGroup();
              } else {
                this.alertService.warning({
                  html: '<b> Loan was not completed</b>'
                });
              }
            },
            err => {
              this.errored = true;
              this.spinner.hide();
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        } else {
          this.errored = true;
          this.alertService.danger({
            html: '<b>Secret pin does not much</b>'
          });
        }
      } else {
        this.errored = true;
        this.alertService.danger({
          html: '<b>Please select a customer</b>'
        });
      }
    }
  }
}
